export default __webpack_public_path__ + "static/media/7SA513.5c9a1af8.jpg";